import { useTranslation } from 'react-i18next';

import { Textarea } from 'components/Form/Input/Textarea/Textarea';

export function OrderNotes({
  value,
  onChange,
  disabled,
}: {
  value?: string;
  onChange: (value: string) => void;
  disabled: boolean;
}) {
  const { t } = useTranslation();
  return (
    <>
      <span className="font-bold text-gray-900">{t('orderForms:checkout.orderNotes.label')}</span>
      <Textarea
        placeholder={t('orderForms:checkout.orderNotes.placeholder')}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </>
  );
}
